module.exports = __webpack_public_path__ + "img/o-clock.44ea1953.gif";